import { ScrollText } from "lucide-react"
import { Button } from "@/components/ui/Button"

export const EmptyContractsState = (
  <div className="p-6 flex flex-col items-center justify-center h-full min-h-[400px] text-center">
    <div className="p-4 rounded-full bg-muted/50 mb-4">
      <ScrollText className="size-8 text-muted-foreground" />
    </div>
    <h3 className="text-foreground font-semibold mb-2">No Contracts Yet</h3>
    <p className="text-muted-foreground text-sm max-w-sm">
      Add contracts to this deal to track agreements, terms, and signatures.
    </p>
    <Button variant="secondary" className="mt-4">
      <ScrollText className="size-4 mr-2" />
      Add Contract
    </Button>
  </div>
)
